// ;(function(doc, win) {
//     var docEl = doc.documentElement,
//         resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize',
//         recalc = function() {
//             var clientWidth = docEl.clientWidth;
//             if (!clientWidth) return;
//             if(clientWidth < 600){
//                 docEl.style.fontSize = 100 * document.body.clientWidth / 750 + 'px';
//             }else{
//                 docEl.style.fontSize = 100 * 600 / 750 + 'px';
//             }

//         };

//     if (!doc.addEventListener) return;
//     win.addEventListener(resizeEvt, recalc, false);
//     doc.addEventListener('DOMContentLoaded', recalc, false);
// })(document, window);
import { Toast } from 'mint-ui';

(function (win, lib) {
	var doc = win.document;
	var docEl = doc.documentElement;
	var metaEl = doc.querySelector('meta[name="viewport"]');
	var flexibleEl = doc.querySelector('meta[name="flexible"]');
	var dpr = 0;
	var scale = 0;
	var tid;
	var flexible = lib.flexible || (lib.flexible = {});

	if (metaEl) {
		var match = metaEl.getAttribute('content').match(/initial\-scale=([\d\.]+)/);
		if (match) {
			scale = parseFloat(match[1]);
			dpr = parseInt(1 / scale);
		}
	} else if (flexibleEl) {
		var content = flexibleEl.getAttribute('content');
		if (content) {
			var initialDpr = content.match(/initial\-dpr=([\d\.]+)/);
			var maximumDpr = content.match(/maximum\-dpr=([\d\.]+)/);
			if (initialDpr) {
				dpr = parseFloat(initialDpr[1]);
				scale = parseFloat((1 / dpr).toFixed(2));
			}
			if (maximumDpr) {
				dpr = parseFloat(maximumDpr[1]);
				scale = parseFloat((1 / dpr).toFixed(2));
			}
		}
	}

	if (!dpr && !scale) {
		var isAndroid = win.navigator.appVersion.match(/android/gi);
		var isIPhone = win.navigator.appVersion.match(/iphone/gi);
		var devicePixelRatio = win.devicePixelRatio;
		if (isIPhone) {
			// iOS下，对于2和3的屏，用2倍的方案，其余的用1倍方案
			if (devicePixelRatio >= 3 && (!dpr || dpr >= 3)) {
				dpr = 3;
			} else if (devicePixelRatio >= 2 && (!dpr || dpr >= 2)) {
				dpr = 2;
			} else {
				dpr = 1;
			}
		} else {
			// 其他设备下，仍旧使用1倍的方案
			dpr = 1;
		}
		scale = 1 / dpr;
	}

	docEl.setAttribute('data-dpr', dpr);
	if (!metaEl) {
		metaEl = doc.createElement('meta');
		metaEl.setAttribute('name', 'viewport');
		metaEl.setAttribute(
			'content',
			'initial-scale=' + scale + ', maximum-scale=' + scale + ', minimum-scale=' + scale + ', user-scalable=no'
		);

		if (docEl.firstElementChild) {
			docEl.firstElementChild.appendChild(metaEl);
		} else {
			var wrap = doc.createElement('div');
			wrap.appendChild(metaEl);
			doc.write(wrap.innerHTML);
		}
	}

	function refreshRem() {
		var width = docEl.getBoundingClientRect().width;
		// 适配平板
		if (width / dpr > 540) {
			width = 540 * dpr;
		}
		var rem = width / 10;
		docEl.style.fontSize = rem + 'px';
		flexible.rem = win.rem = rem;
	}

	win.addEventListener(
		'resize',
		function () {
			clearTimeout(tid);
			tid = setTimeout(refreshRem, 300);
		},
		false
	);
	win.addEventListener(
		'pageshow',
		function (e) {
			if (e.persisted) {
				clearTimeout(tid);
				tid = setTimeout(refreshRem, 300);
			}
		},
		false
	);

	if (doc.readyState === 'complete') {
		doc.body.style.fontSize = 12 * dpr + 'px';
	} else {
		doc.addEventListener(
			'DOMContentLoaded',
			function (e) {
				doc.body.style.fontSize = 12 * dpr + 'px';
			},
			false
		);
	}

	refreshRem();

	flexible.dpr = win.dpr = dpr;
	flexible.refreshRem = refreshRem;
	flexible.rem2px = function (d) {
		var val = parseFloat(d) * this.rem;
		if (typeof d === 'string' && d.match(/rem$/)) {
			val += 'px';
		}
		return val;
	};
	flexible.px2rem = function (d) {
		var val = parseFloat(d) / this.rem;
		if (typeof d === 'string' && d.match(/px$/)) {
			val += 'rem';
		}
		return val;
	};
})(window, window['lib'] || (window['lib'] = {}));

// 获取地址栏参数
export const QueryString = function (name) {
	var params = location.search.replace('?', '').split('&');
	var query = {};
	for (var i = 0; i < params.length; i++) {
		var temp = params[i].split('=');
		if (temp) query[temp[0]] = temp[1];
	}
	var type = query[name]; //渠道
	return type ? type : null;
};

// 手机号码中间四位用*号代替
export const MaskPhoneNumber = function (phoneNumber) {
	if (phoneNumber && phoneNumber.length === 11) {
		return phoneNumber.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2');
	}
	return phoneNumber;
};

// 将阿拉伯数字翻译成中文的大写数字
export const numberToChinese = function (num) {
	let AA = new Array('零', '一', '二', '三', '四', '五', '六', '七', '八', '九', '十');
	let BB = new Array('', '十', '百', '仟', '萬', '億', '点', '');
	let a = ('' + num).replace(/(^0*)/g, '').split('.');
	let k = 0;
	let re = '';
	for (let i = a[0].length - 1; i >= 0; i--) {
		switch (k) {
			case 0:
				re = BB[7] + re;
				break;
			case 4:
				if (!new RegExp('0{4}//d{' + (a[0].length - i - 1) + '}$').test(a[0])) {
					re = BB[4] + re;
				}
				break;
			case 8:
				re = BB[5] + re;
				BB[7] = BB[5];
				k = 0;
				break;
		}
		if (k % 4 === 2 && a[0].charAt(i + 2) !== 0 && a[0].charAt(i + 1) === 0) {
			re = AA[0] + re;
		}
		if (a[0].charAt(i) !== 0) {
			re = AA[a[0].charAt(i)] + BB[k % 4] + re;
		}
		k++;
	}
	if (a.length > 1) {
		// 加上小数部分(如果有小数部分)
		re += BB[6];
		for (let i = 0; i < a[1].length; i++) {
			re += AA[a[1].charAt(i)];
		}
	}
	if (re === '一十') {
		re = '十';
	}
	if (re.match(/^一/) && re.length === 3) {
		re = re.replace('一', '');
	}
	return re;
};

export const CopyText = function (text) {
	const textToCopy = text;
	// 使用 Clipboard API（异步方式）
	if (navigator.clipboard) {
		console.log('navigator.clipboard');
		navigator.clipboard
			.writeText(textToCopy)
			.then(() => {
				Toast({ message: '复制成功', position: 'bottom' });
			})
			.catch(error => {
				// // 处理不同类型的错误
				// if (error.name === "NotAllowedError") {
				//   Toast("用户拒绝了剪贴板访问权限");
				// } else if (error.name === "SecurityError") {
				//   Toast("浏览器限制了对剪贴板的访问");
				// } else {
				//   Toast("复制操作发生错误:", error);
				// }
				const tempInput = document.createElement('textarea');
				tempInput.value = textToCopy;
				document.body.appendChild(tempInput);

				tempInput.select();
				tempInput.setSelectionRange(0, 99999); // 兼容iOS

				try {
					document.execCommand('copy');
					Toast({ message: '复制成功', position: 'bottom' });
				} catch (err) {
					Toast({ message: '复制失败，请手动复制', position: 'bottom' });
				}

				document.body.removeChild(tempInput);
			});
	}
	// 使用 document.execCommand() 方法（同步方式）
	else {
		console.log('document.execCommand');
		const tempInput = document.createElement('textarea');
		tempInput.value = textToCopy;
		document.body.appendChild(tempInput);

		tempInput.select();
		tempInput.setSelectionRange(0, 99999); // 兼容iOS

		try {
			document.execCommand('copy');
			Toast({ message: '复制成功', position: 'bottom' });
		} catch (err) {
			Toast({ message: '复制失败', position: 'bottom' });
		}

		document.body.removeChild(tempInput);
	}
};

export const CheckWeChatPlatform = function () {
	let userAgent = navigator.userAgent.toLowerCase();
	if (userAgent.indexOf('android') !== -1) {
		return 'android';
	} else if (/iphone|ipad|ipod/.test(userAgent)) {
		return 'ios';
	} else {
		return '';
	}
};


// 减法精度计算
export const matchReduce = function(a, b) {
	return ((a * 1000 - b * 1000) / 1000).toFixed(2);
}


// WEBPACK FOOTER //
// ./src/util/index.js